import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../utils/config";
import TabsWi from "../Componant/Widget/TabsWi";

// import { MdDeleteForever } from "react-icons/md";
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import NewTopNavBar from "./NewTopNavBar";
// import 'bootstrap-css-only/css/bootstrap.min.css';
import GlobalContext from "../context/GlobalContext";

function CreateOraUsers() {
  const [users, setUsers] = useState([]);

  const [collaps, setCollaps] = useState(true);
  const [reload, setReload] = useState(false);

  const [allTenents, setallTenents] = useState([]);

  const { setShowMenu } = useContext(GlobalContext);

  // create randompassword
  const currentUserId = localStorage.getItem("current_user_Id");

  const getTenentData = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        console.log("telentData76=", res.data);
        if (res.data.length > 0) {
          const TenentData = res.data.filter((data) => {
            if (data.tenent_user_id == currentUserId) {
              return data;
            }
          });
          setallTenents(TenentData);
          // setTenents(TenentData)
          if (TenentData.length > 0) {
            setShowMenu(true);
          } else {
            setShowMenu(false);
            navigate("/default-page");
          }
          console.log("tenantData=", TenentData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let bearerToken = localStorage.getItem("jwt_token");

  console.log("lin");
  //
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
      // 'X-Wp-Nonce': '6de9be6ced',
      // 'Content-Type': 'application/json',
    },
  };

  // let bearerToken = localStorage.getItem('jwt_token');

  const navigate = useNavigate();

  let current_user_Id = localStorage.getItem("current_user_Id");
  console.log("current_user_Id=", current_user_Id);

  console.log("line804", users);

  useEffect(() => {
    getTenentData();
  }, []);
  //   const scripts = [
  //     `<script>
  //   window.KrWidgetSettings = {
  //   apiBase: "${
  //     window.location.origin === "http://localhost:3000"
  //       ? "http://localhost:3060"
  //       : window.location.origin + "/backend_cosmos"
  //   }/widget/commonScript",
  //   displayName: "<DISPLAY_NAME>", /* IMPORTANT: Replace "<DISPLAY_NAME>" with the variable you use to capture the user's name */
  //   userEmail: "<USER_EMAIL>" /* IMPORTANT: Replace "<USER_EMAIL>" with the variable you use to capture the user's email address */
  // };
  //  </script>`,
  //     `<script> !function(){var t=window,e=t.KrWidget;if("function"==typeof e)e("update",t.KrWidgetSettings);else{var a=document,n=function(){n.c(arguments)};n.q=[],n.c=function(t){n.q.push(t)},t.KrWidget=n;var r=function(){var e=a.createElement("script");e.type="text/javascript",e.async=!0,e.src=t.KrWidgetSettings.apiBase;var n=a.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};"complete"===document.readyState?r():t.attachEvent?t.attachEvent("onload",r):t.addEventListener("load",r,!1)}}(); </script>`,
  //   ];

  return (
    <div>
      <div>
        <div className="row g-0">
          <div
            className={
              collaps ? "column right-column  col" : "column right-column  col "
            }
          >
            <div className="w-100">
              <NewTopNavBar />
            </div>
            <div className="container mt-3">
              <TabsWi />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateOraUsers;
